"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceCatalog = void 0;
// (C) 2019-2020 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var availableItemsFactory_1 = require("./availableItemsFactory");
var BearWorkspaceCatalog = /** @class */ (function () {
    function BearWorkspaceCatalog(authCall, workspace, catalogGroups, items, options, mappings) {
        this.authCall = authCall;
        this.workspace = workspace;
        this.catalogGroups = catalogGroups;
        this.items = items;
        this.options = options;
        this.mappings = mappings;
    }
    BearWorkspaceCatalog.prototype.groups = function () {
        return this.catalogGroups;
    };
    BearWorkspaceCatalog.prototype.allItems = function () {
        return this.items;
    };
    BearWorkspaceCatalog.prototype.attributes = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogAttribute);
    };
    BearWorkspaceCatalog.prototype.measures = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogMeasure);
    };
    BearWorkspaceCatalog.prototype.facts = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogFact);
    };
    BearWorkspaceCatalog.prototype.dateDatasets = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogDateDataset);
    };
    BearWorkspaceCatalog.prototype.availableItems = function () {
        return new availableItemsFactory_1.BearWorkspaceCatalogAvailableItemsFactory(this.authCall, this.workspace, this.catalogGroups, this.items, this.options, this.mappings);
    };
    return BearWorkspaceCatalog;
}());
exports.BearWorkspaceCatalog = BearWorkspaceCatalog;
//# sourceMappingURL=catalog.js.map